import React from 'react';
import classNames from 'classnames';
import { motion } from 'framer-motion';
import styles from './AreaBadge.module.scss';
import { useTranslation } from 'features/translator';

interface IAreaBadge {
  title: string;
  isActive: boolean;
  clickHandler: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const AreaBadge: React.FunctionComponent<IAreaBadge> = ({ title, isActive, clickHandler }) => {
  const translation = useTranslation();
  const componentClass = classNames(styles.component, {
    [styles.isActive]: isActive,
  });

  const displayTitle = () => {
    switch (title) {
      case 'Keskusta':
      case 'Centrum':
        return translation.get('areas', 'keskusta');
      case 'Meilahti':
      case 'Mejlans':
        return translation.get('areas', 'meilahti');
      case 'Viikki':
      case 'Vik':
        return translation.get('areas', 'viikki');
      case 'Kumpula':
      case 'Gumtäkt':
        return translation.get('areas', 'kumpula');
      case 'Töölö':
      case 'Tölö':
        return translation.get('areas', 'toolo');
      default:
        return title;
    }
  };

  return (
    <motion.button whileTap={{ scale: 0.9 }} className={componentClass} onClick={clickHandler}>
      {displayTitle()}
    </motion.button>
  );
};

export default AreaBadge;
